export default {"src":"/_next/static/media/yellowcard.a59a7f6e.svg","height":37,"width":163};